<template>
    <modal id="salary-sheet-create-modal"
        size="large"
        v-model="showModal"
        :title="$fieldTitle('add', 'salary', true)"
        :btn-label="$t('run')"
        @submit="submitData" :loading="loading"
        :preloader="preloader">

        <form ref="form" :data-url="`${TENANT_BASE_URL}app/salary-sheet`" @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        :label="$t('month')"
                        type="search-select"
                        v-model="formData.month"
                        list-value-field="name"
                        :placeholder="$placeholder('month', '')"
                        :error-message="$errorMessage(errors, 'month')"
                        :fetch-url="`${apiUrl.COMMON}/get-months`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="multi-select"
                        :label="$t('department')"
                        list-value-field="name"
                        v-model="formData.department_ids"
                        :chooseLabel="$t('department')"
                        :error-message="$errorMessage(errors, 'department_ids')"
                        :fetch-url="apiUrl.SELECTABLE_DEPARTMENT"
                    />
                </div>
                <div class="col-md-12">
                    <app-form-group-selectable
                        type="multi-select"
                        :label="$t('employee')"
                        v-model="formData.user_ids"
                        list-value-field="employee_name"
                        :error-message="$errorMessage(errors, 'user_ids')"
                        :fetch-url="`${apiUrl.TENANT_SELECTABLE_USER}?without=admin&employee=only&with_auth=yes&departments=${departments}`"
                    />
                </div>
                <div class="col-md-12">
                    <app-form-group
                        type="textarea"
                        :label="$t('note')"
                        :placeholder="$textAreaPlaceHolder('note')"
                        v-model="formData.note"
                        :text-area-rows="4"
                        :error-message="$errorMessage(errors, 'note')">
                    </app-form-group>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";
import {formDataAssigner} from "../../../../common/Helper/Support/FormHelper";

export default {
    name  : "SalarySheetCreateModal",
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            TENANT_BASE_URL,
            departments: 0,
            formData   : {},
        }
    },
    watch  : {
        'formData.department_ids': {
            handler  : function (ids) {
                this.departments = ids || 0
            },
            immediate: true
        }
    },
    methods: {
        submitData() {
            this.loading   = true
            const url      = this.$refs.form.dataset["url"];
            const formData = formDataAssigner(new FormData, this.formData);

            formData.set('department_ids', JSON.stringify(this.formData.department_ids))
            formData.set('user_ids', JSON.stringify(this.formData.user_ids))

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#salary-sheet-create-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'salary-sheet-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.formData  = response.data;
        },
    },
}
</script>
